<template>
  <v-card flat outlined>
    <v-card-actions>
      <strong class="subtitle-1"><i>Bundle Count Discounts</i></strong>
      <v-spacer></v-spacer>
      <v-alert v-if="edit_priority" type="info" class="ma-0 mr-2 pa-2" dense>The fields are disabled, click and drag rows up or down to change priority</v-alert>
      <v-spacer v-if="edit_priority"></v-spacer>
      <v-btn @click="edit_priority = false" v-if="edit_priority">Done Editing Priority Order</v-btn>
      <v-btn @click="edit_priority = true" v-else>Edit Priority</v-btn>
    </v-card-actions>
    <v-divider></v-divider>
    <v-card-text>
      <v-simple-table>
<!--        <thead>-->
<!--          <tr>-->
<!--            <th>Bundle Name</th>-->
<!--            <th>Condition</th>-->
<!--            <th>Count</th>-->
<!--            <th>Discount</th>-->
<!--            <th>Allowed Categories</th>-->
<!--            <th>Remove Bundle</th>-->
<!--          </tr>-->
<!--        </thead>-->
        <VueDraggable :disabled="!edit_priority" v-model="bundles" draggable=".draggable" tag="tbody" @change="updatePriority">
          <tr v-for="(bundle, index) in bundles" :class="`${bundle.$softDelete ? 'error lighten-2' : ''} draggable`">
            <td>
              {{index+1}}
            </td>
            <td>
              <v-text-field v-model="bundle.name" label="name" :disabled="edit_priority"></v-text-field>
            </td>
            <td>
              <v-select v-model="bundle.condition" :items="conditions" label="condition" :disabled="edit_priority"></v-select>
            </td>
            <td>
              <v-text-field v-model="bundle.count" type="number" label="Count" :disabled="edit_priority"></v-text-field>
            </td>
            <td>
              <v-text-field v-model="bundle.discount" label="Discount" prefix="$" :disabled="edit_priority"></v-text-field>
            </td>
            <td>
              <v-select v-model="bundle.allowed_tests" :items="sampleTestTypes" item-text="name" item-value="uuid" label="Allowed Test Types" multiple :disabled="edit_priority"></v-select>
            </td>
            <td>
              <v-select v-model="bundle.allowed_categories" :items="sampleCertTypeCategories" item-text="name" item-value="uuid" label="Allowed Categories" multiple :disabled="edit_priority"></v-select>
            </td>
            <td>
              <v-select v-model="bundle.has_tests" :items="sampleTestTypes" label="Has Tests" item-text="name" item-value="uuid" multiple :disabled="edit_priority"></v-select>
            </td>
            <td>
              <v-select v-model="bundle.excluded_promotions" :items="promotions" label="Excluded promotions" item-text="name" item-value="imperative_name" multiple :disabled="edit_priority"></v-select>
            </td>
            <td class="text-center">
              <v-btn v-if="!bundle.$softDelete" color="error" outlined @click="remove(bundle)" small shaped :disabled="edit_priority"><v-icon>remove</v-icon></v-btn>
              <v-tooltip v-else bottom>
                <template v-slot:activator="{on}">
                  <v-btn v-on="on" outlined @click="bundle.$softDelete = false" small shaped :disabled="edit_priority"><v-icon>undo</v-icon></v-btn>
                </template>
                <span>Undo deletion</span>
              </v-tooltip>
            </td>
          </tr>
        </VueDraggable>
      </v-simple-table>
      <v-row justify="center">
        <v-btn class="success" @click="add" dark><v-icon>add</v-icon> Create Bundle</v-btn>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
    name: "BillingBundleCounts",
    components: {
      VueDraggable: () => import('vuedraggable')
    },
    watch:{
       bundles:{
        deep: true,
        handler(v){
          this.originalBundles = v
        }
      },
    },
    computed:{
      sampleTestTypes(){
        return this.$store.$db().model('sampleTestTypes').all();
      },
      sampleCertTypeCategories(){
        return this.$store.$db().model('sampleCertTypeCategories').all();
      },
      promotions(){
        return this.$store.$db().model('billingPromotions').all();
      },
      originalBundles: {
        get: function(){
          return this.$store.$db().model('billingBundleDiscounts').query().orderBy('priority').all();
        },
        set: function(v){
          return this.$store.$db().model('billingBundleDiscounts').insertOrUpdate({data: v})
        }
      }
    },
    data: () => ({
      allow_bundles: true,
      edit_priority: false,
      bundles: [],
      conditions: [
          "<",
          "<=",
          ">",
          ">=",
          "==="
      ],
      categories: [
          "GPM",
          "SOL",
          "ISL",
          "OTHER"
      ],
      loading: false,
      loadingError: false,
    }),
    mounted(){
      this.load()
    },
    methods: {
      async load(){
        this.loading = true;
        this.loadingError = false;
        this.bundles = [];
        try{
          await this.$store.$db().model('billingBundleDiscounts').load();
          this.reset();
        }catch(e){
          this.loadingError = true;
          console.log(e);
        }finally{
          this.loading = false;
        }
      },
      add(){
        this.$store.$db().model('billingBundleDiscounts').add();
        this.reset();
      },
      remove(item){
        if(item.$isNew){
          item.$delete();
          this.reset();
        }else{
          item.$softDelete = true;
        }
      },
      async updatePriority(){
        for(let i = 0; i < this.bundles.length; i+=1){
          this.bundles[i].priority = i;
        }
      },
      reset(){
        this.bundles = this.originalBundles;
      }
    }
}
</script>

<style scoped>

</style>
